import { LoggedInUserActionTypes } from "../types/Actions";
import { firebaseUser } from "../firebase";

const loggedInUserReducerDefaultState: firebaseUser | null = null;

const loggedInUserReducer = (
    state: firebaseUser | null = loggedInUserReducerDefaultState,
    action: LoggedInUserActionTypes
): firebaseUser | null => {
    switch (action.type) {
        case "LOGGED_IN":
            return action.user;
        case "LOGGED_OUT":
            return null;
        default:
            return state;
    }
}

export default loggedInUserReducer;
